import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import styled from 'styled-components';

import RenderTextField from '../../../../utils/renderFields/RenderTextField';
import { addCollaborator } from '../../userProfileActions';
import validate from './validate';
import collaborator from '../../../../img/collaborator.svg';
import { Title } from '../style';

const FlatIllustration = styled.img`
  position: absolute;
  bottom: 0;
  right: 0;
  width: 74%;
`;

/* eslint-disable import/no-mutable-exports */
let Collaborator = ({ handleSubmit }) => (
  <div style={{ height: '100%' }}>
    <FlatIllustration src={collaborator} />
    <Title>Ajouter un collaborateur</Title>
    <Typography variant="subtitle2" gutterBottom>
      Vous pouvez inviter l&lsquo;un de vos collègues à rejoindre votre compte
      Sympl. Il recevra un SMS avec un code collaborateur à rentrer au moment de
      son inscription. Il aura alors accès aux mêmes fonctionnalités que vous.{' '}
    </Typography>
    <form onSubmit={handleSubmit} noValidate>
      <Grid container spacing={7}>
        <Grid item md={5}>
          <Field
            name="lastname"
            id="lastname"
            label="Nom"
            fullWidth
            component={RenderTextField}
          />
        </Grid>
      </Grid>
      <Grid container spacing={7}>
        <Grid item md={5}>
          <Field
            name="firstname"
            id="firstname"
            label="Prénom"
            fullWidth
            component={RenderTextField}
          />
        </Grid>
      </Grid>
      <Grid container spacing={7}>
        <Grid item md={5}>
          <Field
            name="email"
            id="email"
            label="Email"
            fullWidth
            component={RenderTextField}
          />
        </Grid>
      </Grid>
      <Grid container spacing={7}>
        <Grid item md={5}>
          <Field
            name="phoneNumber"
            id="phoneNumber"
            label="Numéro de téléphone"
            fullWidth
            component={RenderTextField}
          />
        </Grid>
      </Grid>
      <Grid container justify="center" item md={5} style={{ marginTop: 90 }}>
        <Button variant="contained" color="primary" type="submit">
          Ajouter un collaborateur
        </Button>
      </Grid>
    </form>
  </div>
);

Collaborator.propTypes = {
  handleSubmit: PropTypes.func
};

Collaborator = reduxForm({
  form: 'addCollaborator',
  validate,
  onSubmit: (values, dispatch) => {
    dispatch(addCollaborator(values));
  }
})(Collaborator);

export default Collaborator;
